import {
    collectMacroTokensFromSchedule,
    collectMacroTokensFromContent,
} from "authoring/routes/macro/lib/macro-token-utils"
import { getAudienceAmendsContents } from "../../amends/lib/audience-aware-amends.mjs"

export function collectDraftTokenIdSet(initialDraft, draft, amendsWithKeys, allAmends) {
    const tokenIds = new Set()
    collectMacroTokensFromSchedule(initialDraft, tokenIds)
    collectMacroTokensFromSchedule(draft, tokenIds)
    collectTokensFromAmends(amendsWithKeys, tokenIds)
    collectTokensFromAmends(allAmends, tokenIds)
    return tokenIds
}

export function collectDraftTokenIds(initialDraft, draft, amendsWithKeys, allAmends) {
    return [...collectDraftTokenIdSet(initialDraft, draft, amendsWithKeys, allAmends)]
}

export function collectTokensFromAmends(amends, tokenSet) {
    for (const amend of amends ?? []) {
        for (const content of getAudienceAmendsContents(amend?.payload)) {
            collectMacroTokensFromContent(content, tokenSet)
        }
    }
}

export function findUnknownMacroTokens(schedule, macroLookup = {}) {
    if (!schedule) return []
    const tokenIds = [...collectMacroTokensFromSchedule(schedule)]
    if (!tokenIds.length) return []
    return tokenIds.filter((tokenId) => !isResolvableToken(tokenId, macroLookup))
}

export function formatUnknownMacroMessage(tokens = []) {
    const unique = [...new Set(tokens)]
    const listed = unique
        .slice(0, 5)
        .map((token) => `$${token}$`)
        .join(", ")
    if (unique.length <= 5) {
        return `Unrecognized macros: ${listed}`
    }
    return `Unrecognized macros: ${listed} and ${unique.length - 5} more`
}

export function isResolvableToken(tokenId, macroLookup = {}) {
    if (!tokenId) return false
    if (`${tokenId}`.startsWith("cmp:")) return true
    const token = macroLookup?.[tokenId]
    if (!token) return false
    return !token.broken
}

export function createSaveConflictError() {
    return new Error("Conflict")
}
